module.exports = __webpack_public_path__ + "img/gallery16.7e271c8b.jpg";